import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Stack, Text, IconButton, ScreenWidthMinXLarge, ScreenWidthMinLarge, Icon, mergeStyleSets, PrimaryButton } from '@fluentui/react';
import { NeutralColors, SharedColors } from '@fluentui/theme';
const titleAndContentTokens = {
    childrenGap: 20
};
const contentAndBottomTokens = {
    childrenGap: 24
};
const cancelIcon = {
    iconName: 'Cancel'
};
const iconButtonStyles = {
    root: {
        color: NeutralColors.gray160
    }
};
const infoIconStyles = {
    root: {
        fontSize: 16,
        marginRight: 8,
        color: SharedColors.red20
    }
};
const failureConsentModalClassNames = mergeStyleSets({
    description: {
        color: NeutralColors.gray130
    }
});
const modalStyles = {
    main: {
        [`@media (min-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '30%'
        },
        [`@media (min-width: ${ScreenWidthMinLarge}px) and (max-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '50%'
        },
        [`@media (max-width: ${ScreenWidthMinLarge}px)`]: {
            width: '80%'
        },
        display: 'flex'
    },
    scrollableContent: {
        padding: '16px 27px 24px 24px',
        [`@media (max-width: ${ScreenWidthMinLarge}px)`]: {
            padding: '16px 20px 24px 20px'
        }
    }
};
export const FailureConsentModal = ({ dismissModal, shouldSkipModal, showContactMeError }, context)=>{
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: !shouldSkipModal,
        onDismiss: dismissModal,
        styles: modalStyles,
        children: /*#__PURE__*/ _jsxs(Stack, {
            tokens: titleAndContentTokens,
            children: [
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        horizontal: true,
                        children: [
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                grow: true,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    variant: "xLarge",
                                    children: context.loc('Failure_Consent_Modal_Title', "Couldn't send contact request")
                                })
                            }),
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                children: /*#__PURE__*/ _jsx(IconButton, {
                                    styles: iconButtonStyles,
                                    iconProps: cancelIcon,
                                    ariaLabel: context.loc('Dialog_Close'),
                                    onClick: dismissModal
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        tokens: contentAndBottomTokens,
                        children: [
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                children: /*#__PURE__*/ _jsxs(Stack, {
                                    horizontal: true,
                                    children: [
                                        /*#__PURE__*/ _jsx(Stack.Item, {
                                            children: /*#__PURE__*/ _jsx(Icon, {
                                                iconName: "Info",
                                                styles: infoIconStyles
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Stack.Item, {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                variant: "medium",
                                                className: failureConsentModalClassNames.description,
                                                children: showContactMeError ? context.loc('ContactMeError_Description_Text', 'There was a problem sending your request. Please try again later.') : context.loc('Failure_Consent_Modal_Description', 'There was a problem sending the contact request. Check your network connection and try again.')
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                align: "end",
                                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                                    text: context.loc('Dialog_Close'),
                                    ariaLabel: context.loc('Dialog_Close'),
                                    onClick: dismissModal
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
FailureConsentModal.contextTypes = {
    loc: PropTypes.func
};
